import { User } from '../types';

type NameableUser = User & {
  first_name?: string | null;
  last_name?: string | null;
};

const fullName = (first?: string | null, last?: string | null): string => {
  return `${first || ''} ${last || ''}`.trim();
};

export const getDisplayName = (user: NameableUser | null | undefined): string => {
  if (!user) return 'User';
  const profileDisplay = (user.profile?.display_name || '').trim();
  if (profileDisplay) return profileDisplay;
  const prospectName = fullName(user.prospect?.first_name, user.prospect?.last_name);
  if (prospectName) return prospectName;
  const profileName = fullName(user.profile?.first_name, user.profile?.last_name);
  if (profileName) return profileName;
  const userName = fullName(user.first_name, user.last_name);
  if (userName) return userName;
  if (user.username) return user.username;
  if (user.email) return user.email;
  return `User #${user.id}`;
};

export const getInitials = (user: NameableUser | null | undefined): string => {
  const label = getDisplayName(user);
  const parts = label.split(/\s+/).filter(Boolean);
  const initials = (parts[0]?.[0] || '') + (parts[1]?.[0] || '');
  return (initials || label.slice(0, 1) || 'U').toUpperCase();
};
